.card-wrapper {
  display: block;
}

.vcard {
  margin: 10px 0;
 }

 .disclosure{
  max-width: 400px;
  display: block;
 }